export default function contactForm() {
  $(document).ready(function() {
    $('section.contact div.contact-reason div.container-select-block ul.container-select-list li').on('click', function() {
      var value = $(this).attr('data-contact')
      var trimmedValue = value.trim()
      $('section.contact form').hide()
      setTimeout(() => {
        const formSelector = `section.contact form[name="${trimmedValue}"]`
        const $form = $(formSelector)
        if ($form.length === 0) {
        } else {
          $('section.contact div.form-container').fadeIn()
          $form.fadeIn()
        }
        $('section.contact div.type-client input').on('change', function() {
          var value = $(this).attr('data-show-form')
          if (value == 1) {
            $('section.contact form[name="Reclamações sobre produtos"] input.wholesalers').show()
            $('section.contact form[name="Reclamações sobre produtos"] div.customers').css('display', 'grid')
            $('section.contact form[name="Reclamações sobre produtos"] div.product').show()
            $('section.contact form[name="Reclamações sobre produtos"] div.sending').css('display', 'flex')
          } else if (value == 2) {
            $('section.contact form[name="Reclamações sobre produtos"] div.customers').css('display', 'grid')
            $('section.contact form[name="Reclamações sobre produtos"] input.wholesalers').hide()
            $('section.contact form[name="Reclamações sobre produtos"] div.product').show()
            $('section.contact form[name="Reclamações sobre produtos"] div.sending').css('display', 'flex')
          } else if (value == 3) {
            window.open('https://sac.parceiros.nutrire.ind.br/', '_blank')
          }
        })
      }, 500)
    })

    // url
    window.onload = function() {
      let urlParams = window.location.href
      if (urlParams.includes('filter=newsletter')) {
        $('.contact-reason .container-select-block')
          .find('input.select-input')
          .val('Newsletter')
          .attr('value', 'Newsletter')
        $('.contact-reason .container-select-block')
          .find('.select .container-select span')
          .text('Newsletter')
        $('section.contact div.form-container').fadeIn()
        $('form.sendForm[name="Newsletter"]').show()
        $('html, body').animate(
          {
            scrollTop: $('.contact-reason').offset().top,
          },
          1000
        )
      }
    }

    const apiUrl = 'https://servicodados.ibge.gov.br/api/v1/localidades/municipios'

    $.getJSON(apiUrl, function(data) {
      let cityList = $('.city-search .container-select-list')
      cityList.empty()

      let allCities = []

      data.forEach(city => {
        let cityOption = `<li class="option" data-city="${city.nome}">
                                <span>${city.nome}</span>
                              </li>`
        allCities.push(cityOption)
      })

      cityList.append(allCities.join(''))

      $('.city-search .select-input').on('input', function() {
        let searchValue = $(this)
          .val()
          .toLowerCase()

        let cityList = $(this)
          .closest('.container-select-block')
          .find('.container-select-list')

        if (searchValue.length > 0) {
          cityList.addClass('open')
        } else {
          cityList.removeClass('open')
        }
        let filteredCities = allCities.filter(city => city.toLowerCase().includes(searchValue))
        cityList.empty().append(filteredCities.join(''))
        $(this).attr('value', searchValue)
      })
    })

    $(document).on('click', '.city-search .container-select-list .option', function() {
      let selectedCity = $(this).data('city')
      $('.city-search input')
        .val(selectedCity)
        .attr('value', selectedCity)
    })
  })
}
